import type { OnboardingQuestion } from './types';

/**
 * Preguntas compartidas por varios perfiles de empresa.
 *
 * Se definen una sola vez para que la redacción y las opciones sean
 * consistentes entre sectores: el tamaño del equipo y el acceso de clientes
 * externos se preguntan igual a un despacho de abogados que a una oficina de
 * ingeniería.
 */

/** Dimensiona el plan sugerido. */
export const TEAM_SIZE_QUESTION: OnboardingQuestion = {
  key: 'team_size',
  label: '¿Cuántas personas trabajarán en este espacio?',
  type: 'select',
  required: true,
  options: [
    { value: '1', label: 'Sólo yo (freelance)' },
    { value: '2-5', label: '2 a 5' },
    { value: '6-20', label: '6 a 20' },
    { value: '21-50', label: '21 a 50' },
    { value: '50+', label: 'Más de 50' },
  ],
  helpText: 'Usamos este dato para recomendarte el plan adecuado.',
};

/** Activa por defecto enlaces con caducidad y registro de accesos. */
export const CLIENT_ACCESS_QUESTION: OnboardingQuestion = {
  key: 'external_client_access',
  label: '¿Compartirás archivos con clientes externos?',
  type: 'boolean',
  helpText: 'Configuraremos enlaces con caducidad, contraseña y registro de accesos.',
};

/** Ajusta el tamaño máximo por archivo y el historial de versiones. */
export const CAD_FILES_QUESTION: OnboardingQuestion = {
  key: 'cad_files',
  label: '¿Trabajas con archivos CAD, BIM o modelos 3D (DWG, IFC, RVT, STEP)?',
  type: 'boolean',
  helpText: 'Ajustamos el tamaño máximo por archivo y el historial de versiones.',
};

/** Relevante en sectores con obligaciones de conservación documental. */
export const REGULATED_DATA_QUESTION: OnboardingQuestion = {
  key: 'regulated_data',
  label: '¿Manejas documentación sujeta a plazos legales de conservación?',
  type: 'boolean',
  helpText: 'Destacaremos la retención de papelera y el historial de versiones de tu plan.',
};
